import { Button, Menu } from '@oliasoft-open-source/react-ui-library';
import { useTranslation } from 'react-i18next';
import translations from 'client/internationalization/translation-map.json';
import { IUser } from 'common/interfaces/customer-interfaces';

interface UserMenuProps {
  navToUserProfile: () => void;
  navToCompanies: () => void;
  onClickLogOut: () => void,
  user: IUser | null;
  selectedCustomer: any
}

export const UserMenu = ({
  navToUserProfile,
  navToCompanies,
  onClickLogOut,
  user,
  selectedCustomer,
}: UserMenuProps) => {
  const { t } = useTranslation();

  const userNameArr = [user?.firstName, user?.lastName];
  const initials = userNameArr.map(n => (n || '').charAt(0)).join('').toUpperCase();
  const name = userNameArr.join(' ');

  const userMenu = [
    selectedCustomer && {
      type: 'Heading',
      label: selectedCustomer.customerLabel,
      testId: 'user-menu-company-name',
    },
    {
      type: 'Heading',
      label: name,
    },
    selectedCustomer && {
      type: 'Option',
      label: t(translations.settings_userSettings),
      icon: 'user',
      testId: 'user-menu-option-user-settings',
      onClick: navToUserProfile,
      visible: true,
    },
    selectedCustomer && {
      type: 'Option',
      label: t(translations.settings_switchCompany),
      icon: 'refresh',
      testId: 'user-menu-option-switch-company',
      onClick: navToCompanies,
      visible: true,
    },
    {
      type: 'Option',
      label: t(translations.helpCenter),
      icon: 'help',
      testId: 'user-menu-option-help',
      visible: true,
    },
    {
      type: 'Option',
      label: t(translations.signOut),
      icon: 'lock',
      onClick: onClickLogOut,
      visible: true,
    },
    { type: 'Divider' },
    {
      type: 'Option',
      label: APP_VERSION,
      disabled: true,
    },
  ];

  return (
    <Menu
      testId="user-menu-component-menu"
      offset={10}
      menu={{
        trigger: 'Component',
        placement: 'bottom-end',
        component: <Button label={initials} colored round onClick={() => {}} />,
        sections: userMenu,
      }}
    />
  );
};
